import type { Props as ScoringProps } from "./scoring";
import type { TeamData } from "../../_model";
import { createMemo, createSignal, For, onMount } from "solid-js";
import { global } from ":shared/app";
import URLViewer from "./url-viewer";
import Scoring from "./scoring";
import { Accordion } from ":ui/foldable";

type Props = ScoringProps & {
  onNext: () => void;
  onPrevious: () => void;
  onBack: () => void;
};

const SECTIONS = {
  members: {
    title: "team members",
    id: "members",
  },
  presentation: {
    title: "presentation",
    id: "presentation",
  },
  details: {
    title: "project details",
    id: "project_details",
  },
  attached: {
    title: "project attached",
    id: "project_attached",
  },
};

export default function Grading(props: Props) {
  let ref: HTMLDivElement = undefined;
  const [$active_section, setActiveSection] = createSignal(SECTIONS.presentation);
  const $team = createMemo(() => {
    if (ref) {
      ref.scrollTo({ top: 0 });
      // setActiveSection(0);
    }
    return props.team;
  });
  const track = global.store.actions.flavors.getBadgeStyle({ track: props.team.track });
  const team_info_keys: (keyof TeamData)[] = [
    "problem_statement",
    "applicable_solution",
    "impact",
    "business_model",
    "feasibility",
    "ideation",
    "research_process",
  ];

  onMount(() => {
    if (ref == undefined) {
      return;
    }
    // let ids = "";
    // for (const key in SECTIONS) {
    //   const value = SECTIONS[key];
    //   ids += `#${value.id} `;
    // }
    // const sections = ref.querySelectorAll("#main ");
    // const navLi = ref.querySelectorAll("nav .container ul li");
    // ref.onscroll = () => {
    //   console.log("active section :: ", sections);
    //   var current = "";

    //   sections?.forEach((section) => {
    //     // const sectionTop = section.offsetTop;
    //     // if (pageYOffset >= sectionTop - 60) {
    //     //   current = section.getAttribute("id");
    //     // }
    //   });

    //   // navLi.forEach((li) => {
    //   //   li.classList.remove("active");
    //   //   if (li.classList.contains(current)) {
    //   //     li.classList.add("active");
    //   //   }
    //   // });
    // };
  });

  function Title(props: { title: string; link?: string }) {
    return (
      <p class="flex flex-row text-16px min-h-40px items-center text-text-alt gap2 overflow-hidden">
        <span>{props.title}</span>
        {props.link && (
          <a class="flex w-fit h-full" href={props.link} target="_blank">
            <i class="i-akar-icons:link-out w-20px h-full text-brand" />
          </a>
        )}
      </p>
    );
  }

  function Separator() {
    return <div class="w-full min-h-4px bg-bg-alt my-2" />;
  }

  return (
    //
    <div class="grid grid-rows-[40px_1fr_40px] w-full h-full gap2 overflow-hidden">
      <div onclick={() => props.onBack?.()} class="flex flex-row w-full h-full items-center justify-between gap2">
        <div class="form-btn !text-14px !w-fit !h-full !bg-bg !text-text gap2 border-2 border-solid border-bg-alt whitespace-nowrap">
          <i class="i-tabler:arrow-left w-16px h-full text-text-alt" />
          Back
        </div>
        {$team()?.scores?.total && (
          <div class="flex flex-row !text-14px gap2 rounded-md px-2 py1 border-2 border-solid border-success-shade">
            <span class="text-text-alt">Grade:</span>
            <span class="text-success">{$team()?.scores?.total}</span>
          </div>
        )}
      </div>
      <section class="flex w-full h-full overflow-hidden">
        <div ref={ref} class="flex flex-row w-full h-full gap-2 overflow-x-hidden overflow-y-auto">
          {/* tabs */}
          <section class="sticky top-0 flex flex-col w-25% h-full text-15px capitalize gap-1 children:(px-2 py-2 w-full h-fit no-underline)">
            <For each={Object.keys(SECTIONS)}>
              {(key, index) => {
                const item = SECTIONS[key];
                const $active = createMemo(() => $active_section().id === item.id);
                return (
                  <a
                    class={"rounded-md" + " " + ($active() ? "bg-bg-alt" : "")}
                    href={"#" + item.id}
                    onclick={() => setActiveSection(item)}
                  >
                    {item.title}
                  </a>
                );
              }}
            </For>
          </section>
          {/* info */}
          <section id="#main" class="flex flex-col w-full min-h-full gap2">
            {/* title */}
            <div class="w-full text-20px font-bold capitalize">{$team().project_name ?? "Nameless"}</div>
            {/* track and status */}
            <div class="flex flex-row h-fit text-14px items-center justify-start gap-1">
              <p style={track?.style} class="flex w-fit h-full rounded-md px-2 py-1 capitalize">
                {$team().track}
              </p>
              {/* <p>{$team().eval_id == undefined ? "Pending" : "Evaluated"}</p> */}
            </div>
            {/* team members */}
            {/* <div id={SECTIONS.members.id}>
              team members
            </div> */}
            {/* presentation */}
            <div id={SECTIONS.presentation.id} class="flex flex-col w-full min-h-300px h-300px gap2 !overflow-hidden">
              <Title title="Presentation" link={$team().presentation} />
              <URLViewer url={$team().presentation} type="pdf" />
            </div>
            <Separator />
            {/* questions and answers */}
            <div id={SECTIONS.details.id} class="flex flex-col w-full h-fit gap2">
              {team_info_keys.map((ti, i) => {
                const title = String(!ti ? "Untitled Question" : ti.replaceAll("_", " "));
                const value = (props.team?.[ti] as string) ?? "Not Answered";
                return (
                  <Accordion
                    arrowMode="hidden"
                    class="w-full h-fit rounded-md border-2px border-solid border-border-card"
                    activeClass="border-brand"
                    groupClass="flex flex-row space-x-2 py-3 px-3"
                    title={({ isOpen }) => {
                      return (
                        <section class="flex flex-row justify-center items-center w-full text-16px">
                          <div class="font-700 font-semibold text-start w-full">
                            <h2 class="text-black text-16px font-600 capitalize">{title}</h2>
                          </div>
                          {isOpen ? (
                            <i class="i-raphael:arrowup w-15px h-15px" />
                          ) : (
                            <i class="i-raphael:arrowdown w-15px h-15px" />
                          )}
                        </section>
                      );
                    }}
                  >
                    <div class="flex flex-col justify-between text-16px pt-1 pb-2.5 px-25px!">
                      <p class="text-text-alt ">{value.length <= 0 ? "Not Answered" : value}</p>
                    </div>
                  </Accordion>
                );
              })}
            </div>
            <Separator />
            {/* cover */}
            <div id={SECTIONS.attached.id} class="flex flex-col w-full min-h-300px h-300px gap2 !overflow-hidden">
              <Title title="Illustration" link={$team().project_images} />
              <URLViewer url={$team().project_images} type="pdf" />
            </div>
            {/* video */}
            <div class="flex flex-col w-full min-h-300px h-300px gap2 !overflow-hidden">
              <Title title="Cover" link={$team().project_video} />
              <URLViewer url={$team().project_video} type="link" />
            </div>
          </section>
          {/* scoring */}
          <section class="!sticky !top-0 min-w-35% h-fit !overflow-hidden">
            <Scoring criteria={props.criteria} team={$team()} onSubmit={props.onSubmit} onGraded={props.onGraded} />
          </section>
        </div>
      </section>
      <div class="flex flex-row w-full h-full gap-x-2 justify-between items-center overflow-hidden children:(!w-fit !h-40px !text-16px border-2 border-solid border-bg-alt !bg-bg !text-text)">
        <button class="form-btn gap1" onClick={() => props.onPrevious?.()}>
          <i class="i-tabler:arrow-left w-16px h-full text-text-alt" />
          Previous
        </button>
        <button class="form-btn gap1" onClick={() => props.onNext?.()}>
          Next
          <i class="i-tabler:arrow-right w-16px h-full text-text-alt" />
        </button>
      </div>
    </div>
  );
}
